export const API_URL = 'https://example-data.draftbit.com/books?_limit=80';
export const BOOK_DETAILS_URL = 'https://example-data.draftbit.com/books/';
export const MY_COLLECTIONS_URL = 'https://book-keeper-2e244-default-rtdb.firebaseio.com/datas.json';
export const MY_REVIEWS_URL = 'https://book-keeper-2e244-default-rtdb.firebaseio.com/reviews.json';
export const CONTACTS_URL = 'https://book-keeper-2e244-default-rtdb.firebaseio.com/contacts.json'
export const USER_DATA = 'https://book-keeper-2e244-default-rtdb.firebaseio.com/user.json'


  